import { LuBuilding2, LuHome, LuBriefcase, LuBedDouble, LuMapPin } from "react-icons/lu";
import { TbChevronRight } from "react-icons/tb";

const ADDRESS_SUB_TYPE_ICONS: Record<string, React.ReactElement> = {
  apartment: <LuBuilding2 size={20} />,
  house:     <LuHome size={20} />,
  office:    <LuBriefcase size={20} />,
  hotel:     <LuBedDouble size={20} />,
  other:     <LuMapPin size={20} />,
};

type Props = {
  address: string;
  city: string;
  phone?: string;
  addressSubType?: string;
  label: string;
  onClick: () => void;
};

const DeliveryAddressCard: React.FC<Props> = ({ address, city, phone, addressSubType = "apartment", label, onClick }) => {
  const icon = ADDRESS_SUB_TYPE_ICONS[addressSubType] ?? ADDRESS_SUB_TYPE_ICONS.apartment;

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: "8px", width: "100%", marginTop: "20px" }}>
      <span style={{ fontSize: "13px", color: "#98a0af", fontWeight: 600 }}>
        {label}
      </span>
      <div
        onClick={onClick}
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          height: "56px",
          padding: "11px 21px 11px 13px",
          border: "1px solid #dbe1eb",
          borderRadius: "6px",
          background: "white",
          cursor: "pointer",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
          <span style={{ display: "flex", alignItems: "center", color: "#3e3e3e" }}>
            {icon}
          </span>
          <div style={{ display: "flex", flexDirection: "column", gap: "2px" }}>
            <span style={{ fontSize: "14px", fontWeight: 500, color: "#3e3e3e", lineHeight: "18px" }}>
              {address}
            </span>
            <span style={{ fontSize: "12px", color: "#666", lineHeight: "16px" }}>
              {city}{phone ? ` - ${phone}` : ""}
            </span>
          </div>
        </div>
        <TbChevronRight size={20} color="#3e3e3e" />
      </div>
    </div>
  );
};

export default DeliveryAddressCard;
